var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a-select',_vm._b({on:{"focus":_setup.onFocus,"deselect":(...args) => _setup.onDeselect(args),"blur":_setup.onBlur}},'a-select',{..._vm.$attrs, ..._vm.$props},false))
}
var staticRenderFns = []

export { render, staticRenderFns }